import { NavDisplayConfig } from '../types';
import { MagpieConnection } from 'magpie-lib/connection';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { MessageOf } from 'magpie-lib/models';

interface Params {
  appName: string;
}

export type NavVisibility = MessageOf<
  typeof navVisibilityControls.navVisibility
>['payload'];

export class NavInteractions {
  static #instance: NavInteractions;

  private constructor(private readonly params: Params) {}

  static getInstance(params: Params): NavInteractions {
    if (!NavInteractions.#instance) {
      NavInteractions.#instance = new NavInteractions(params);
    }

    return NavInteractions.#instance;
  }

  getCurrentVisibility = (): Promise<NavVisibility> => {
    const topic = MagpieConnection.get().useTopic(navigationPublicApiTopicDef);
    const getVisibility = navVisibilityControls.getNavVisibility.create();
    return new Promise((res) =>
      topic.publish(getVisibility, { onReply: ({ payload }) => res(payload) })
    );
  };

  useNavDisplayConfig = (config: NavDisplayConfig | undefined): void => {
    if (!config) {
      return;
    }
    const topic = MagpieConnection.get().forTopic(navigationPublicApiTopicDef);
    const changeVisibility = navVisibilityControls.changeNavVisibility.create({
      source: this.params.appName,
      shouldShowVerticalNav: config.shouldShowNav,
      shouldShowToolbar: config.shouldShowToolbar,
    });
    topic.publish(changeVisibility, { onReply() {} });
  };
}
